module.exports = __webpack_public_path__ + "static/img/positionTop2.4a15826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/positionTop2.png
// module id = cXbU
// module chunks = 2